import type { StaticEntityType } from "@config";
import { PdfLinkToSrc } from "@library/components/pdf";
import { IconLibrary } from "./Icon.library";

export const IconPdf = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity;
  return (
    <IconLibrary
      entity={entity}
      editorSlots={{
        pdfLinkToSrcSlot: <PdfLinkToSrc src={settings.linkUrl} />,
      }}
    />
  );
};
